import React from "react"

import cls from 'classnames'
import * as pageStyles from 'styles/pages/template/template.module.scss';

import { Layout } from "components/organisms/Layout"
import { BackgroundImage } from "components/organisms/BackgroundImage";
import { StaticImage } from "gatsby-plugin-image";
import { Promo } from "components/organisms/Promo";
import { ModalForm } from "components/organisms/ModalForm";
import { reviews } from "data/unified-java-runtime/reviews";
import { ReviewsSlider } from "components/organisms/ReviewsSlider";
import { HeadFC } from "gatsby";

const IndexPage = () => {
    return (
        <Layout button={{ className: 'bg-cyan' }}>

            <BackgroundImage
                alt={"BG Image"}
                className={pageStyles.bg}
                desktop={
                    <StaticImage src={"../../images/pages/template/promo-desktop.png"} alt={""} />
                }
                tablet={
                    <StaticImage src={"../../images/pages/template/promo-mobile.png"} alt={""} />
                }
                mobile={
                    <StaticImage src={"../../images/pages/template/promo-mobile.png"} alt={""} />
                }
            >
                <Promo
                    components={{
                        title: 'h3'
                    }}
                    title="A Step-by-Step Guide to CRA Vulnerability and Incident Reporting"
                    className={cls(pageStyles.promocontainer)}
                    description={
                        <div className={cls("p-2", pageStyles.pageDescription)}>
                            <p className={"color-gray"}>
                                Starting 11 September 2026, manufacturers and open-source software stewards must report actively exploited vulnerabilities
                                and severe security incidents under the EU Cyber Resilience Act. A failure to report may lead to fines of up
                                to €15 million or 2.5% of worldwide turnover.
                            </p>
                            <p className="color-white">
                                The reporting deadlines are short and strict, so you need to understand the process before an incident happens. We put together a practical CRA Reporting
                                Cheat Sheet that turns CRA Article 14 requirements into a step-by-step workflow you can use during preparation and response.
                            </p>
                            <div className="color-gray" style={{ margin: '5px 0', marginBottom: '15px' }}>
                                Use this Cheat Sheet to assess
                                <ul style={{ listStyleType: 'disc', paddingLeft: '20px', paddingTop: '10px' }}>
                                    <li className="color-gray">Whether you and your product is in scope</li>
                                    <li className="color-gray">Which events are considered reportable</li>
                                    <li className="color-gray">Which CSIRT you should report to</li>
                                    <li className="color-gray">How to register and submit a report through the ENISA SRP</li>
                                    <li className="color-gray">What is the reporting timeline</li>
                                    <li className="color-gray">What information must be submitted within 24 hours, 72 hours, and in the final report</li>
                                </ul>
                            </div>
                        </div>
                    }
                    childrenClassNames={{
                        contentWrapper: pageStyles.contentWrap
                    }}
                    additionalContentNode={(
                        <div className={cls(pageStyles.successModal, pageStyles.contentModal)}>
                            <ModalForm
                                title={
                                    <>
                                        <p className={pageStyles.formTitle}>Get Your Free Copy</p>
                                        <br />
                                    </>
                                }
                                classNames={{
                                    details: pageStyles.formDetails
                                }}
                                form={{
                                    items: [
                                        {
                                            name: 'firstname',
                                            placeholder: 'Name',
                                            gridColumn: '1/3'
                                        },
                                        {
                                            name: 'company',
                                            placeholder: 'Company',
                                            gridColumn: '1/3'
                                        },
                                        {
                                            name: 'email',
                                            required: true,
                                            placeholder: 'Work e-mail',
                                            gridColumn: '1/3'
                                        },
                                        {
                                            name: 'mobilephone',
                                            placeholder: 'Phone',
                                            gridColumn: '1/3'
                                        },
                                    ],
                                    formId: "81cf9741-fc15-4c1e-a19c-161ac8385de6",
                                    controls: {
                                        terms: {
                                            name: "privacystatement",
                                            caption: <span className="color-gray">I agree with <a
                                                className={pageStyles.terms} href="/terms-of-use/">Terms</a> and <a
                                                    className={pageStyles.terms} href="/privacy-policy/">Privacy</a></span>,
                                            className: pageStyles.terms,
                                        },
                                        button: {
                                            caption: "Grab your copy",
                                            className: "button-filled bg-cyan color-white transition-m hover-bg-cyan"
                                        }
                                    }
                                }}
                                successDetails="Thank you!"
                                successTitle="The whitepaper is on the way to your inbox. We hope you enjoy reading it."
                            />
                        </div>
                    )}
                    additionalContentNodePosition={"end"}
                    buttons={[]}
                />
            </BackgroundImage>

            <ReviewsSlider
                items={reviews}
                title="What customers say about our support"
                theme="dark"
                className={cls(pageStyles.bg, pageStyles.reviews)}
            />
        </Layout >
    )
}

export default IndexPage;

export const Head: HeadFC = () => {
    return (
        <>
            <title>CRA Vulnerability & Incident Reporting: Step-by-Step Guide | BellSoft Java</title>
            <meta name="description"
                content="Learn how to report vulnerabilities and incidents under EU CRA Article 14. Free cheat sheet covers scope, CSIRT selection, ENISA SRP, and 24/72-hour deadlines." />
            <meta name="keywords"
                content="BellSoft, Java Applications, Java Developers, Java Experts, Java Technologies, Software Developers, Java Performance Engineers" />
        </>
    )
}